import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Helmet from 'react-helmet';
import { Container, Row, CardColumns, Card, CardImgOverlay, Label, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import VisibilitySensor from 'react-visibility-sensor';

import config from '../../../../config';

import { enabledLanguages } from '../../../../../Intl/setup';
import { capitalizeFirstLetter } from '../../../../util/text';

import { getPublicReviewsRequest, getReviews } from '../../ReviewActions';
import { getContentBlockItemByName } from '../../../Cms/CmsActions';

import ReviewListItem from '../../components/list/ReviewListItem';

import FontCustom from '../../../../components/Content/FontCustom';
import HtmlComponent from '../../../../components/Text/HtmlComponent';
import Breadcrumbs from '../../../App/components/view/Breadcrumbs';
import FileLoader from '../../../../components/Content/FileLoader';
import CmsPanel from '../../../Cms/components/content/CmsPanel';


class ReviewListPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            language: props.intl.locale,
            type: '',
            dropdownLanguageOpen: false,
            isLoading: false,
            start: -1,
            isEnd: false,
        };
    }

    componentDidMount() {
        this.handleFetchReviews();
    }

    componentDidUpdate(prevProps, prevState) {
        if(
            prevState.language !== this.state.language
            || prevState.type !== this.state.type
        ) {
            this.handleFetchReviews(true);
        }
    }

    handleFetchReviews = (isReset = false) => {
        this.setState(({
            isLoading: true,
            start: isReset === true ? -1 : this.state.start,
        }), () => {
            this.props.dispatch(getPublicReviewsRequest(this.state.language, this.state.start + 1)).then(reviews => {
                this.setState({
                    isLoading: false,
                    start: this.state.start + 1,
                    isEnd: !reviews || !reviews.length,
                });
            });
        });
    }

    getReviews = () => {
        return this.props.reviews.filter(review => (!this.state.language || review.language === this.state.language)
            && (
                !this.state.type
                || (this.state.type === 'video' && review.link)
                || (this.state.type === 'text' && !review.link && review.text)
            ));
    }

    toggleDropdownLanguage = () => {
        this.setState({
            dropdownLanguageOpen: !this.state.dropdownLanguageOpen,
        });
    }

    handleVisibilityChange = isVisible => {
        if(isVisible && !this.state.isLoading && !this.state.isEnd) {
            this.handleFetchReviews();
        }
    }

    render() {
        const { page } = this.props;
        const image = getContentBlockItemByName(page.blocks, 'image');
        const title = getContentBlockItemByName(page.blocks, 'title');
        const content = getContentBlockItemByName(page.blocks, 'content');

        return (
            <Container>
                <Card>
                    {image && <FileLoader filename={image.path} loadonmount className="card-img" style={{ minHeight: '200px' }} />}
                    <CardImgOverlay>
                        <Breadcrumbs crumb={page && page.title} />
                    </CardImgOverlay>
                </Card>
                <div className={classnames(image && 'override-block-lg')}>

                    {title && (
                        <h1 className="position-relative py-5 text-center text-dark font-weight-bold">
                            <span className="position-relative" style={{ zIndex: 2 }}>{title.text}</span>
                            <span className="position-absolute w-100 text-center text-light" style={{ top: '20px', left: '0', zIndex: 1 }}>
                                <FontCustom name="quote" size="10" />
                            </span>
                        </h1>
                    )}
                    {content && <HtmlComponent text={content.text} />}

                    <div className="mt-3">
                        <div className="mb-3 d-flex justify-content-center">
                            <span className="d-none d-md-inline" style={{ lineHeight: '2.5em' }}><FormattedMessage id="reviewFilterLabel" defaultMessage="Filter reviews" /></span>
                            <div className="mx-2 px-4 pt-2 bg-light">
                                <Label className="mr-2"><FormattedMessage id="reviewFilterLanguageLabel" defaultMessage="By language" /></Label>
                                <ButtonDropdown isOpen={this.state.dropdownLanguageOpen} toggle={event => this.toggleDropdownLanguage()} className="mr-4">
                                    <DropdownToggle nav caret className="p-0">
                                        {capitalizeFirstLetter(this.state.language)}
                                    </DropdownToggle>
                                    <DropdownMenu className="text-center" style={{ minWidth: 'auto' }}>
                                        {enabledLanguages.filter(lang => lang !== this.state.language).map(lang => (
                                            <DropdownItem key={lang} size="sm" onClick={() => this.setState({ language: lang })}>
                                                <span className={lang === this.props.intl.locale ? 'selected' : ''}>
                                                    {capitalizeFirstLetter(lang)}
                                                </span>
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </ButtonDropdown>

                                {['text', 'video'].map((type, index) => <span key={type} className={classnames(this.state.type === type && 'font-weight-bold')} onClick={() => this.setState({ type })}>{index > 0 && <span className="d-inline-block px-2">|</span>}<FormattedMessage id={`reviewType${capitalizeFirstLetter(type)}Label`} defaultMessage={capitalizeFirstLetter(type)} /></span>)}

                                {(this.state.language || this.state.type) && (
                                    <small className="d-inline-block pl-4" onClick={event => this.setState({ language: '', type: '' })}><FontAwesome name="times" /> <FormattedMessage id="reviewFilterClear" defaultMessage="Reset filters" /></small>
                                )}
                            </div>
                        </div>
                        <Row>
                            {this.getReviews().map(review => <ReviewListItem key={review._id} review={review} />)}
                        </Row>

                        <CmsPanel slug="review-disclaimer-info" />

                        <div className="mt-3 text-center">
                            {
                                this.state.isLoading
                                ? <FontAwesome name="spinner" spin size="2x" />
                                : (
                                    <Fragment>
                                        {!this.state.isEnd && <VisibilitySensor onChange={this.handleVisibilityChange}><Button color="warning" outline size="sm" onClick={() => this.handleFetchReviews()}><FormattedMessage id="loadMore" defaultMessage="Load more..." /></Button></VisibilitySensor>}
                                    </Fragment>
                                )
                            }
                        </div>
                    </div>
                </div>
            </Container>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        reviews: getReviews(store, 'validated'),
    };
}

ReviewListPage.defaultProps = {
    reviews: [],
};

ReviewListPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    page: PropTypes.object.isRequired,
    reviews: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(injectIntl(ReviewListPage));


export const ReviewListPageModel = {
    type: 'page',
    name: 'reviews',
    slug: 'reviews',
    blocks: [
        {
            name: 'image', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'image', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'content', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'html', // || text || link || image || mixed (with children)
        },
    ],
};
